// extracted by mini-css-extract-plugin
export default {"zoomControls":"naa-z","zoomControlButton":"oaa-z","zoomBanner":"paa-z","bannerButton":"qaa-z","imageButton":"raa-z","zoom":"saa-z","zoomContent":"taa-z"};